import axios from "axios";
// List products with Api
export const GetCourses = async (jwt, languaje) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/course/list`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'language_id': languaje
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};